import { FormFieldComponentProps } from './fieldProps';

const LabelField = ({ field }: FormFieldComponentProps) => {
	return <div className='biz-form-field__label-display'>{field.label}</div>;
};

export default LabelField;
